module.exports = __webpack_public_path__ + "5227ac357dd1c36313cffaecafc9dfb5.jpg";